<template>
  <span class="text-xs font-semibold tracking-wide uppercase min-w-20 text-center bg-green-200 text-green-700 px-2 py-1 rounded-lg border border-green-500" :class="badge_class">{{ text }}</span>
</template>

<script>
export default {
  name: "BadgeSuccess",
  props: {
    text: String,
    badge_class: String
  }
}
</script>